import { useQuery, UseQueryOptions } from 'react-query';
import { getTemplateRevisionIds } from '@/experiment-management-shared/api/library-panel/api';
import { RevisionDetail } from '@/experiment-management-shared/api/library-panel/types';

export default function usePanelTemplateRevisions(
  templateId: string,
  config: UseQueryOptions<RevisionDetail[]>
) {
  return useQuery<RevisionDetail[]>(
    ['panelTemplateRevisions', { templateId }],
    async () => {
      const revisions = await getTemplateRevisionIds({ templateId });
      return revisions.revisionDetails.sort(
        (a, b) =>
          new Date(b.revision).getTime() - new Date(a.revision).getTime()
      );
    },
    config
  );
}
